import { render, staticRenderFns } from "./Page5.vue?vue&type=template&id=38571820&scoped=true"
import script from "./Page5.vue?vue&type=script&lang=js"
export * from "./Page5.vue?vue&type=script&lang=js"
import style0 from "./Page5.vue?vue&type=style&index=0&id=38571820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38571820",
  null
  
)

export default component.exports